import React from 'react'
import { AdvancedFilter } from 'components/Filter/AdvancedFilter'
import { ProvisionImpairmentReversalDetail } from './ProvisionImpairmentReversalDetail/ProvisionImpairmentReversalDetail'
import { ProvisionImpairmentReversalForm } from './ProvisionImpairmentReversalForm/ProvisionImpairmentReversalForm'
import { ProvisionImpairmentReversalMain } from './ProvisionImpairmentReversalMain'

const provisionImpairmentReversalRoutes = [
  /* -------------------------------------------- */
  /*                ADVANCED FILTER               */
  /* -------------------------------------------- */
  {
    props: {
      exact: true,
      path:
        '/fixed-assets/:CompanyID/assets-change/provision-for-impairment-reversal/filter',
    },
    component: (
      <AdvancedFilter
        mode="assets-change"
        app="fixed-assets"
        hasStatus
        hasDocDate
        hasDateRange
      />
    ),
  },

  /* -------------------------------------------- */
  /*                     MAIN                     */
  /* -------------------------------------------- */

  {
    props: {
      exact: true,
      path:
        '/fixed-assets/:CompanyID/assets-change/provision-for-impairment-reversal',
    },
    component: <ProvisionImpairmentReversalMain />,
  },

  /* -------------------------------------------- */
  /*                     FORM                     */
  /* -------------------------------------------- */

  {
    props: {
      exact: true,
      path:
        '/fixed-assets/:CompanyID/assets-change/provision-for-impairment-reversal/add',
    },
    component: (
      <ProvisionImpairmentReversalForm
        formMode="add"
        type="ASSETS_REGISTRATION"
      />
    ),
  },
  {
    props: {
      exact: true,
      path:
        '/fixed-assets/:CompanyID/assets-change/provision-for-impairment-reversal/:ProvisionImpairmentReversalID/edit',
    },
    component: <ProvisionImpairmentReversalForm formMode="edit" />,
  },

  /* -------------------------------------------- */
  /*                    DETAIL                    */
  /* -------------------------------------------- */

  {
    props: {
      exact: true,
      path:
        '/fixed-assets/:CompanyID/assets-change/provision-for-impairment-reversal/:ProvisionImpairmentReversalID/detail',
    },
    component: <ProvisionImpairmentReversalDetail />,
  },
]

export default provisionImpairmentReversalRoutes
